/**
 * Car.info attribut-id — speglar backend/src/services/carinfo/carInfoSpecIds.ts.
 * Tolka ALDRIG fält via attributnamn (text kan ändras).
 */

// Laddhybrid = 141 (Bensin) + 143 (El). 145 = E85/Etanol, 146 = Naturgas, 147 följer El.
export const SPEC_ID_BRANSLE_BENSIN = '141';
export const SPEC_ID_BRANSLE_DIESEL = '142';
export const SPEC_ID_BRANSLE_ELECTRIC = '143';
export const SPEC_ID_BRANSLE_HYBRID = '144';
export const SPEC_ID_BRANSLE_ETHANOL = '145';
export const SPEC_ID_BRANSLE_GAS = '146';
export const SPEC_ID_BRANSLE_ELECTRIC_COMPANION = '147';

export const SPEC_ID_TANK_VOLUME_MIN = '156';
export const SPEC_ID_FUEL_CONSUMPTION_WLTP_COMBINED = 'g320';
export const SPEC_ID_CO2_WLTP_COMBINED = 'g321';
export const SPEC_ID_SEATS = 'g3';
export const SPEC_ID_SEATS_ALT = 'g149';
export const SPEC_ID_EV_RANGE_WLTP_MIN = '2632';
export const SPEC_ID_TRANSMISSION_AUTOMATIC = '927';
export const SPEC_ID_TRANSMISSION_VALUE = 'g7';
export const SPEC_ID_VEHICLE_TAX = '1298';
export const SPEC_ID_VEHICLE_MALUS = '3415';
export const SPEC_ID_TAXATION_MONTHS = 'g201';
export const EXT_NEXT_INSPECTION = 'e1159';
export const EXT_IN_TRAFFIC = 'e1150';
